var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-title",class:{ 'mark': _vm.isMark },style:({ 'font-size': _vm.fontSize })},[_vm._t("default",[_c('span',[_vm._v(_vm._s(_vm.title))])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }